import { render, staticRenderFns } from "./ModuleDetailsContainer.vue?vue&type=template&id=db7a5ff8"
import script from "./ModuleDetailsContainer.vue?vue&type=script&lang=js"
export * from "./ModuleDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports